import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DS_breakpoints as coreBreakpoints } from 'mui/base/theme/DS_Tokens/core';
import useSelector from 'components/Booking-new/hooks';
import useMatchMedia from 'utils/hooks/useMatchMedia';
import { resetLocationsOrder } from 'utils/booking/resetLocationsOrder';

import { ChooseLocationDesktop, ChooseLocationMobile } from './components/ChooseLocation';

import { ChangeServiceLinkType, LocationDataType, LocationType, SearchedLocationType } from './types';

const VariantA = ({
  stepLocationData,
  changeServiceLink,
  userData,
  showNewsBanner,
  funnelType,
  navigation,
  serviceCode,
  rescheduleData,
}) => {
  const [selectedLocation, setSelectedLocation] = useState(userData?.selectedLocation || null);
  const [closestLocations, setClosestLocations] = useState(stepLocationData?.locations);
  const isSelectedLocation = userData?.isSelected || false;
  const { results } = useSelector(state => ({
    currentState: state,
  }));

  const isMobile = useMatchMedia(`(max-width:${coreBreakpoints['lg']}rem)`);

  const resetSelectedLocation = useCallback(() => {
    const reOrderedLocations = resetLocationsOrder(results.currentState?.locations, stepLocationData?.sortingAlgorithm);
    setClosestLocations(reOrderedLocations);
  }, [results.currentState?.locations]);

  const stepLocationCommonProps = {
    stepLocation: stepLocationData,
    closestLocationsState: [closestLocations, setClosestLocations],
    selectedLocationState: [selectedLocation, setSelectedLocation],
    resetSelectedLocation,
    isSelectedLocation,
    changeServiceLink,
    showNewsBanner,
    funnelType,
    navigation,
    allLocations: stepLocationData?.locations,
    serviceCode,
    rescheduleData,
  };

  return (
    <>
      {isMobile ? (
        <ChooseLocationMobile {...stepLocationCommonProps} />
      ) : (
        <ChooseLocationDesktop {...stepLocationCommonProps} innerHeight={innerHeight} />
      )}
    </>
  );
};

export default VariantA;

VariantA.propTypes = {
  stepLocationData: LocationDataType,
  userDataLocation: PropTypes.shape({
    selectedLocation: LocationType,
    searchedLocation: SearchedLocationType,
  }),
  changeServiceLink: ChangeServiceLinkType,
};
